
































































import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { ParagraphSize } from '@getaccept/lib-ui';
import { StatusHelper } from '@getaccept/lib-shared/src/helpers/status.helper';
import type { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import type { ContractDisplaySettings } from '@getaccept/editor-lib/src/types/models';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { RecipientStatus } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-status';
import { EBlockWidth, EditorHelper, toolTipOptions } from '@getaccept/editor-lib';
import { TooltipPlacement } from '@getaccept/lib-shared/src/enums/tooltip-placement';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';

export default defineComponent({
  name: 'SignerDetails',
  props: {
    contractDisplaySettings: {
      type: Object as PropType<ContractDisplaySettings>,
      default: () => ({}),
    },
    isSigningOrder: { type: Number, default: 0 },
    status: { type: String as PropType<RecipientStatus>, default: null },
    role: { type: String, default: '' },
    fullName: { type: String, default: '' },
    email: { type: String, default: '' },
    companyName: { type: String, default: '' },
    title: { type: String, default: '' },
    orderNum: { type: Number, default: null },
    signingPageUrl: { type: String, default: null },
    contractStatus: { type: String as PropType<DocumentStatus>, default: null },
    prevSigner: { type: Object as PropType<Recipient>, default: null },
    blockWidthClass: { type: String as PropType<EBlockWidth>, default: null },
    contractExpired: { type: Boolean, default: null },
  },
  setup(props) {
    const statusBadgeContent = computed(() => ({
      text: StatusHelper.getRecipientStatusTranslation(props.status as RecipientStatus, true),
      statusType: StatusHelper.getRecipientStatusType(props.status as RecipientStatus),
      border: StatusHelper.getRecipientHasBadgeBorder(props.status as RecipientStatus),
    }));

    const formattedTitle = computed(() => {
      if (props.title) {
        return props.blockWidthClass === EBlockWidth.XXSmall ? props.title : ` | ${props.title}`;
      }
      return null;
    });

    const isSigningPageUrlDisabled = computed(
      () => Boolean(isSigningOrderAndNotUserTurn.value) || props.contractExpired
    );

    const isSigningOrderAndNotUserTurn = computed(
      () =>
        props.isSigningOrder &&
        prevSignerStatus.value !== RecipientStatus.Signed &&
        prevSignerStatus.value !== RecipientStatus.Approved &&
        props.status === RecipientStatus.Added &&
        props.orderNum !== 1
    );

    const prevSignerStatus = computed(() => props.prevSigner?.status);

    const getTooltip = computed(() => {
      if (props.contractExpired) {
        return t('contract_expired_cant_access_document');
      }
      if (isSigningOrderAndNotUserTurn.value) {
        return t('cant_access_document_until_prev_signed');
      }
      return null;
    });

    const handleClick = () => {
      window.open(props.signingPageUrl, '_blank');
    };

    return {
      toolTipOptions,
      prevSignerStatus,
      TooltipPlacement,
      isSigningPageUrlDisabled,
      isSigningOrderAndNotUserTurn,
      getTooltip,
      formattedTitle,
      EBlockWidth,
      handleClick,
      statusBadgeContent,
      ParagraphSize,
      isBlockWidthSmall: EditorHelper.isBlockWidthSmall,
    };
  },
});
